import { Dispatch } from "redux";

import {
  COIN_WITHDRAW_ACTIVE_TAB,
  COIN_WITHDRAW_CONFIRM_RESPONSE,
  COIN_WITHDRAW_REDIRECT_URL,
  COIN_WITHDRAW_REQUEST_RESPONSE,
  COIN_WITHDRAW_PENDING_FOR_CHARGE,
  CoinWithdrawDispatchType,
} from "./CoinWithdrawType";
import {
  CoinWithdrawResponse,
  CoinWithdrawConfirmResponse,
} from "../../../models/response/coinWithdraw.response";

export const SetRedirectURL =
  (url?: string) => (dispatch: Dispatch<CoinWithdrawDispatchType>) => {
    try {
      dispatch({
        type: COIN_WITHDRAW_REDIRECT_URL,
        payload: {
          redirectUrl: url,
        },
      });
    } catch (e) {
      dispatch({
        type: COIN_WITHDRAW_REDIRECT_URL,
        payload: {
          redirectUrl: undefined,
        },
      });
    }
  };

export const SetCoinWithdrawPendingForCharge =
  (isPending: boolean) => (dispatch: Dispatch<CoinWithdrawDispatchType>) => {
    try {
      dispatch({
        type: COIN_WITHDRAW_PENDING_FOR_CHARGE,
        payload: {
          pendingForCharge: isPending,
        },
      });
    } catch (e) {
      dispatch({
        type: COIN_WITHDRAW_PENDING_FOR_CHARGE,
        payload: {
          pendingForCharge: isPending,
        },
      });
    }
  };

export const SetCoinWithdrawConfirmResponse =
  (response?: CoinWithdrawConfirmResponse) =>
  (dispatch: Dispatch<CoinWithdrawDispatchType>) => {
    try {
      dispatch({
        type: COIN_WITHDRAW_CONFIRM_RESPONSE,
        payload: {
          coinWithdrawConfirmResponse: response,
        },
      });
    } catch (e) {
      dispatch({
        type: COIN_WITHDRAW_CONFIRM_RESPONSE,
        payload: {
          coinWithdrawConfirmResponse: response,
        },
      });
    }
  };

export const SetCoinWithdrawRequestResponse =
  (response?: CoinWithdrawResponse) =>
  (dispatch: Dispatch<CoinWithdrawDispatchType>) => {
    try {
      dispatch({
        type: COIN_WITHDRAW_REQUEST_RESPONSE,
        payload: {
          coinWithdrawRequestResponse: response,
        },
      });
    } catch (e) {
      dispatch({
        type: COIN_WITHDRAW_REQUEST_RESPONSE,
        payload: {
          coinWithdrawRequestResponse: response,
        },
      });
    }
  };

export const SetActiveTab =
  (activeTab?: "rightSide" | "leftSide") =>
  (dispatch: Dispatch<CoinWithdrawDispatchType>) => {
    try {
      dispatch({
        type: COIN_WITHDRAW_ACTIVE_TAB,
        payload: {
          activeTab: activeTab,
        },
      });
    } catch (e) {
      dispatch({
        type: COIN_WITHDRAW_ACTIVE_TAB,
        payload: {
          activeTab: activeTab,
        },
      });
    }
  };
